import type { DbParticipation, DbParticipationStatus } from '@hub/common';

// Single source of truth for participation-status access decisions. An active
// participation has the full app (home, schedule); any other status is
// restricted to its screening questionnaire and the always-available routes.
export const isActiveParticipation = (
  participation: DbParticipation
): boolean => participation.status === 'active';

export const isPreScreeningParticipation = (
  participation: DbParticipation
): participation is DbParticipation & { status: 'pre-screening' } =>
  participation.status === 'pre-screening';

// Statuses the home route renders as the enrollment landing; every other
// status renders the real home or a terminal shell (ParticipationShell).
export const ENROLLMENT_LANDING_STATUSES = [
  'pre-screening',
  'consenting',
  'consented',
  'pre-screened',
] as const satisfies readonly DbParticipationStatus[];

export type EnrollmentLandingStatus =
  (typeof ENROLLMENT_LANDING_STATUSES)[number];

export const isEnrollmentLandingStatus = (
  status: DbParticipationStatus
): status is EnrollmentLandingStatus =>
  (ENROLLMENT_LANDING_STATUSES as readonly DbParticipationStatus[]).includes(
    status
  );
